<template>
  <b-modal
    :no-close-on-backdrop="true"
    id="modulemail"
    size="sm"
    body-class="bg-white"
    cancel-title="Cancel"
    cancel-variant="light"
    :ok-title-html="mail_id.mail_id!=''?submitted==true?loaderIcon+'Send':'Send': submitted==true?loaderIcon+'Send':'Send'"
    @ok="handlemail"
    :ok-disabled="submitted"
    title="Send Email"
    ref="handlemail"
  >
    <p>Are you sure about email this {{ content }} ?</p>
    <b-row>
      <b-col>
        <b-form-group
          horizontal
          :label-cols="3"
          :label="'Email'"
          label-class="required"
          label-for="mail_id"
        >
          <b-form-input
            type="text"
            size="sm"
            name="mail_id"
            v-model.trim="mail"
            v-validate="'email|required'"
          />

          <span class="text-danger" v-if="errors.has('mail_id')">Please enter valid mail id</span>
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { notificationMixin } from "@/mixins/notification";
import { mapState } from "vuex";

export default {
  mixins: [notificationMixin],
  props: ["content", "module", "mail_id"],
  data() {
    return {
      mail: this.mail_id,
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center"
    };
  },
  methods: {
    handlemail(evt) {
      evt.preventDefault();
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitted = true;
          this.$store
            .dispatch(
              this.module + "/receipt",
              JSON.stringify({
                id: this.$route.params.id,
                mail_id: this.mail
              })
            )
            .then(() => {
              this.submitted = false;

              var message_list = [];
              for (var i = 0; i < this.email.Message.length; i++) {
                message_list.push("<li>" + this.email.Message[i] + "</li>");
              }
              var message = "<ul>" + message_list.join("") + "</ul>";
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: message,
                type: "success",
                showCloseButton: true
              });
              this.$refs.handlemail.hide();
            });
        } else {
          this.submitted = false;
          this.error_show = true; // validate the form if fail
        }
      });
    }
  },

  //  send the json data

  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      email: state => state.general.email
    })
  }
};
</script>

<style>
</style>
